import React, { useEffect, useState, useContext } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import FdapnResponseApiUrls from 'src/apiUrls/FdapnResponseApiUrls'
import AciHighwayKeys from 'src/constants/locale/key/AciHighwayResponse'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment-timezone'
import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@material-ui/core'
import clsx from 'clsx'
import { FdaPNTranslationContext } from './../contexts/FDAPNTranslationContext.js'

const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL }
} = constants

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.background.sectionOddBg,
      '& .MuiTableCell-head': {
        borderBottom: 0,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 0
          }
        }
      }
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px'
    }
  }
}))

function ResponseFdapn(props) {
  const { showNotification, id, isViewOnly = false, manifestId, cargoPage, fdapnData } = props

  const [lookups, setLookups] = useState(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const { fetchRecord, fetchRecords } = useServices()
  const { translate } = useTranslation([Namespace.ACE_HIGHWAY_RESPONSE])
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const classes = useStyles()
  const { getTranslatedText } = useContext(FdaPNTranslationContext)

  const columns = [
    {
      field: 'batchId',
      title: getTranslatedText('FDAPN', 'responseId')
    },
    {
      title: getTranslatedText('FDAPN', 'responseDate'),
      // render: (data) =>
      //   data.responseDate &&
      //   moment(data.responseDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')
      render: (data) => (
        <Grid container spacing={1}>
          {data.responses.map((response, index) => (
            <Grid key={index} item xs={12}>
              {response.responseDate && moment(response.responseDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')}
            </Grid>
          ))}
        </Grid>
      )
    },
    {
      field: 'envelopeNumber',
      title: getTranslatedText('FDAPN', 'envelopeNumber'),
      // render: (data) => data.envelopeNumber
      render: (data) => (
        <Grid container spacing={1}>
          {data.responses.map((response, index) => (
            <Grid key={index} item xs={12}>
              {response.envelopeNumber}
            </Grid>
          ))}
        </Grid>
      )
    },
    {
      field: 'narrativeMsgType',
      title: getTranslatedText('FDAPN', 'narrativeMsgType'),
      // render: (data) => data.narrativeMsgType
      render: (data) => (
        <Grid container spacing={1}>
          {data.responses.map((response, index) => (
            <Grid key={index} item xs={12}>
              {response.narrativeMsgType}
            </Grid>
          ))}
        </Grid>
      )
    },
    {
      field: 'narrativeMsg',
      title: getTranslatedText('FDAPN', 'narrativeMsg'),
      // render: (data) => data.narrativeMsg
      render: (data) => (
        <Grid container spacing={1}>
          {data.responses.map((response, index) => (
            <Grid key={index} item xs={12}>
              {response.narrativeMsg}
            </Grid>
          ))}
        </Grid>
      )
    },
    {
      field: 'processingDate',
      title: getTranslatedText('FDAPN', 'processingDate'),
      // render: (data) =>
      //   data.processingDate &&
      //   moment(data.processingDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')
      render: (data) => (
        <Grid container spacing={1}>
          {data.responses.map((response, index) => (
            <Grid key={index} item xs={12}>
              {response.processingDate && moment(response.processingDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')}
            </Grid>
          ))}
        </Grid>
      )
    },
    {
      field: 'actionCode',
      title: getTranslatedText('FDAPN', 'actionCode')
    },
    {
      field: 'remarks',
      title: getTranslatedText('FDAPN', 'remarks'),
      // render: (data) => data.remarks
      render: (data) => (
        <Grid container spacing={1}>
          {data.responses.map((response, index) => (
            <Grid key={index} item xs={12}>
              {response.remarks}
            </Grid>
          ))}
        </Grid>
      )
    }
  ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value)
    setPage(0)
  }

  return (
    <>
      <TableContainer>
        <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell key={index}>{column.title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {fdapnData.length > 0 ? (
              fdapnData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((d) => (
                  <TableRow key={d.id}>
                    {columns.map((column, index) => (
                      <TableCell key={index}>
                        {column.render ? column.render(d) : d[column.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell align='center' colSpan={columns.length}>
                  <Typography variant='body2' color='textSecondary'>
                    No records to display
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
        component='div'
        count={fdapnData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default ResponseFdapn
